export default __webpack_public_path__ + "static/media/write.3c38fb23.png";